import { profileDetailsSlice } from "./profile";
import { apiErrorSlice } from "./apiErrorHandler";
import { dashboardSlice } from "./dashboard";
import { cartSlice } from "./storeCart";
import { tableSlice } from "./table";
import { menuCartSlice } from "./menuCart";
import { paymentsSlice } from "./payments";
import { checkoutSlice } from "./checkoutInfo";
import { policiesSlice } from "./policy";
import { webSocketSlice } from "./websocket";

export const rootReducer = {
  profileDetailsReducer: profileDetailsSlice.reducer,
  apiErrorReducer: apiErrorSlice.reducer,
  dashboardReducer: dashboardSlice.reducer,
  cartReducer: cartSlice.reducer,
  tableReducer: tableSlice.reducer,
  menuCartReducer: menuCartSlice.reducer,
  paymentsReducer: paymentsSlice.reducer,
  checkoutReducer: checkoutSlice.reducer,
  policiesReducer: policiesSlice.reducer,
  webSocketReducer: webSocketSlice.reducer,
};
